import { render, staticRenderFns } from "./editForm.vue?vue&type=template&id=5b2f0dfc&scoped=true"
import script from "./editForm.vue?vue&type=script&lang=js"
export * from "./editForm.vue?vue&type=script&lang=js"
import style0 from "./editForm.vue?vue&type=style&index=0&id=5b2f0dfc&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f0dfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b2f0dfc')) {
      api.createRecord('5b2f0dfc', component.options)
    } else {
      api.reload('5b2f0dfc', component.options)
    }
    module.hot.accept("./editForm.vue?vue&type=template&id=5b2f0dfc&scoped=true", function () {
      api.rerender('5b2f0dfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/applet/setting/skinForm/editForm.vue"
export default component.exports